module.exports = __webpack_public_path__ + "static/media/champions-page.ec3f7a79.wav";